module.exports = __webpack_public_path__ + "img/nap_m_02.ea7a021f.jpg";